import type { ComponentProps } from "react";

import { cn } from "@/shared/lib/cn";

export function Input({ className, type, ...props }: ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "h-[var(--control-input)] w-full min-w-0 rounded-[var(--radius-sm)] border border-input bg-background/80 px-3 text-base text-foreground shadow-inner outline-none transition-[border-color,box-shadow] placeholder:text-foreground-muted/70 focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/30 disabled:cursor-not-allowed disabled:opacity-50 sm:text-sm",
        className,
      )}
      {...props}
    />
  );
}
